<script lang="ts" setup>
import type { RecommendItem } from '@/utils/type';
import { MAX_RECOMMEND_NUM } from '@/utils/const';
import Item from '../Item/Item.vue';
import { ref } from 'vue';
import { queryList } from '@/tools/queryFreshFinds';
import LoadMore from '@/components/common/LoadMore/LoadMore.vue';
import { isAndroidEnv } from '@/utils';

const props = defineProps<{
    // 组件配置
    contentConfig: {
        defaultExpand: boolean;
        abstractRow: number;
    };
    // 分类 ID
    categoryId: string;
}>();

// 相关推荐数据
const recommendationList = defineModel<RecommendItem[]>('recommendationList', {
    required: true,
});

// 是否没有更多数据
const noMoreData = ref(false);

// 是否正在加载更多
const loadingMore = ref(false);

// 加载更多
const loadMoreContent = async () => {
    // 防止重复加载
    if (loadingMore.value) return;

    // 检查是否已经到达最大推荐数
    if (recommendationList.value.length >= MAX_RECOMMEND_NUM) {
        noMoreData.value = true;
        return;
    }

    loadingMore.value = true;
    const feedsList = await queryList({
        contentTextSwitch: true,
        categoryId: props.categoryId,
    });
    loadingMore.value = false;

    if (feedsList.length === 0) {
        noMoreData.value = true;
        return;
    }

    recommendationList.value = [...recommendationList.value, ...feedsList];

    // 防止页面跟着滚动 (如果是安卓环境)
    if (isAndroidEnv()) {
        document.documentElement.style.overflowY = 'hidden';
        setTimeout(() => {
            document.documentElement.style.overflowY = 'auto';
        }, 500);
    }
};
</script>

<template>
    <div class="card_recommendation_content">
        <template v-for="(item, index) in recommendationList" :key="index">
            <!-- 推荐项目 -->
            <Item :item="item" :contentConfig="contentConfig" />

            <!-- 分割线 -->
            <div
                v-if="index !== recommendationList.length - 1"
                class="card_recommendation_boundary"
            ></div>
        </template>

        <!-- 加载更多 / 结束符 -->
        <div v-if="noMoreData" class="end"></div>
        <LoadMore v-else variant="std-card_rec" @loadMore="loadMoreContent" />
    </div>
</template>

<style lang="scss" scoped>
@use './Content.scss';
</style>
